import { useState } from "react";
import { AccordionItem } from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/accordion-item/AccordionItem";
import Tooltip from "@JohnLewisPartnership/jl-design-system/dist/components/tooltip/Tooltip";
import { ProductAccordionWithMonetateEvents } from "../../ProductAccordionWithMonetateEvents";
import { Attribute } from "@/types/prodcatBaseTypes";
import styles from "./ProductMeasurementsAccordion.module.scss";
import baseStyles from "../../ProductAccordion.module.scss";

type Props = {
  attributes: Attribute[];
  open?: boolean;
};

export function ProductMeasurementsAccordionUI({ attributes, open }: Props) {
  const [isOpen, setIsOpen] = useState(open);
  const defaultHelpText = "Height, Width, Depth";

  if (attributes.length < 1) {
    return null;
  }

  return (
    <ProductAccordionWithMonetateEvents name="Measurements" open={isOpen}>
      <AccordionItem
        data-testid="accordion:measurements"
        header={<h2 className={baseStyles.accordionTitle}>Measurements</h2>}
        isOpen={open}
        onStateChange={(isOpen: boolean) => {
          setIsOpen(isOpen);
        }}
      >
        <div data-testid="product:measurements:accordion">
          <dl data-testid="product:measurements:list">
            {attributes.map((measurement) => (
              <div className={styles.measurement} key={measurement.key}>
                <dt
                  className={styles.measurementTitle}
                  data-testid="product:measurements:list:label"
                >
                  <span>{measurement.displayName}</span>
                  <ProductAttributeToolTip
                    helpText={measurement.helpText || defaultHelpText}
                    toolTipId={measurement.key}
                  />
                </dt>
                <dd
                  className={styles.measurementValue}
                  data-testid="product:measurements:list:value"
                >
                  {measurement.values[0]}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </AccordionItem>
    </ProductAccordionWithMonetateEvents>
  );
}

function ProductAttributeToolTip({
  helpText,
  toolTipId,
}: {
  helpText: string;
  toolTipId: string;
}) {
  return (
    <div
      data-testid="product:measurements:list:label:tooltip"
      className={styles.tooltipWrapper}
    >
      <Tooltip
        id={`tooltip-${toolTipId}`}
        icon
        anchor="right"
        verticalAnchor="top"
      >
        {helpText}
      </Tooltip>
    </div>
  );
}
